import { useEffect } from "react";

const TelegramWidget = ({ onScriptLoad }) => {
  useEffect(() => {
    const redirectUrl = document.referrer + "/auth/callback";
    const handleTelegramAuth = (user) => {
      // Encode the user data for URL
      const encodedPayload = encodeURIComponent(JSON.stringify(user));

      // Redirect to your callback URL with the Telegram payload
      window.location.href = `${redirectUrl}?tgPayload=${encodedPayload}`;
    };

    const script = document.createElement("script");
    script.src = "https://telegram.org/js/telegram-widget.js?22";
    script.async = true;
    script.setAttribute("data-telegram-login", "bp_st_bot");
    script.setAttribute("data-size", "large");
    script.setAttribute("data-onauth", "onTelegramAuth(user)");
    script.setAttribute("data-request-access", "write");
    script.setAttribute("data-auth-url", redirectUrl);

    script.onload = () => {
      // setScriptLoaded(true);
      if (onScriptLoad) onScriptLoad(true);

      // Set the global callback
      window.onTelegramAuth = handleTelegramAuth;
    };

    script.onerror = () => {
      // setScriptLoaded(false);
      if (onScriptLoad) onScriptLoad(false);
    };

    const container = document.getElementById("telegram-login-container");
    if (container) {
      container.appendChild(script);
    }

    return () => {
      delete window.onTelegramAuth;
      const container = document.getElementById("telegram-login-container");
      if (container) {
        container.innerHTML = "";
      }
      if (onScriptLoad) onScriptLoad(false);
    };
  }, [onScriptLoad]);

  return (
    <div
      style={{
        background: "#282c34",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <div id="telegram-login-container" />
    </div>
  );
};

export default TelegramWidget;
